import {userEmployeeSettingsApi} from '../index';
import {EmployeeVoucherLinkDetailsDto} from './dto';
import {AddressInformationRequest} from '../../views/account-settings/requestObjects/intex';

export async function getEmployeeVoucherLinkDetails() {
    return await userEmployeeSettingsApi.get<EmployeeVoucherLinkDetailsDto>('/voucher-link-details');
}

export async function getEmployeeAddressInformationSettings() {
    return await userEmployeeSettingsApi.get<AddressInformationRequest>('/information');
}
